export default "__VITE_ASSET__9f5e0f2f__"